import { data } from 'react-router';
import axios2 from '../api/axios';
export const rolepermissionServices = {
    createpermission,
    getpermissions,
    getroles
}

function createpermission(data){
   return axios2.post('/createpermissions',data).then((response)=>{
         return response;     
    }).catch((error)=>{
         console.log(error); 
    });  
}

function getpermissions(){
   return axios2.get('/getpermissions').then((response)=>{
        return response;     
   }).catch((error)=>{
        console.log(error); 
   });   
}

function getroles(){
     return axios2.get('/getroles').then((response)=>{
          return response;     
     }).catch((error)=>{
          console.log(error); 
     });   
  }
